import { render, staticRenderFns } from "./DialogReceiptResult.vue?vue&type=template&id=236dc4f2&scoped=true&"
import script from "./DialogReceiptResult.vue?vue&type=script&lang=js&"
export * from "./DialogReceiptResult.vue?vue&type=script&lang=js&"
import style0 from "./DialogReceiptResult.vue?vue&type=style&index=0&id=236dc4f2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "236dc4f2",
  null
  
)

export default component.exports